import agentsTypes from '../types/agents';
import api from "../../api/api";

const setAgentsList = (array) => ({
    type: agentsTypes.SET_AGENTS_LIST,
    array,
});
const setNoAgents = (boolean) => ({
    type: agentsTypes.SET_NO_AGENTS,
    boolean,
});
const setSearchByMap = (boolean) => ({
    type: agentsTypes.SET_SEARCH_BY_MAP,
    boolean,
});
const setSearchAddress = (string) => ({
    type: agentsTypes.SET_SEARCH_ADDRESS,
    string,
});
const setLastSearchAddress = (string) => ({
    type: agentsTypes.SET_LAST_SEARCH_ADDRESS,
    string,
});
const setSearchAddressError = (boolean) => ({
    type: agentsTypes.SET_SEARCH_ADDRESS_ERROR,
    boolean,
});
const setSearchName = (string) => ({
    type: agentsTypes.SET_SEARCH_NAME,
    string,
});
const setLastSearchName = (string) => ({
    type: agentsTypes.SET_LAST_SEARCH_NAME,
    string,
});
const setSearchNameError = (boolean) => ({
    type: agentsTypes.SET_SEARCH_NAME_ERROR,
    boolean,
});
const setSearchError = (boolean) => ({
    type: agentsTypes.SET_SEARCH_ERROR,
    boolean,
});
const setAgent = (object) => ({
    type: agentsTypes.SET_AGENT,
    object,
});
const setHoveredAgent = (number) => ({
    type: agentsTypes.SET_HOVERED_AGENT,
    number,
});
const setAgency = (object) => ({
    type: agentsTypes.SET_AGENCY,
    object,
});
const setWorkTime = (array) => ({
    type: agentsTypes.SET_WORK_TIME,
    array,
});
const setAgentSocials = (array) => ({
    type: agentsTypes.SET_AGENT_SOCIALS,
    array,
});
const setAgencyWebsiteList = (array) => ({
    type: agentsTypes.SET_AGENCY_WEBSITE_LIST,
    array,
});
const setDetailsOpen = (boolean) => ({
    type: agentsTypes.SET_DETAILS_OPEN,
    boolean,
});
const setModalOpen = (boolean) => ({
    type: agentsTypes.SET_MODAL_OPEN,
    boolean,
});
const setModalSuccessOpen = (boolean) => ({
    type: agentsTypes.SET_MODAL_SUCCESS_OPEN,
    boolean,
});
const setActiveMarker = (text) => ({
    type: agentsTypes.SET_ACTIVE_MARKER,
    text,
});
const setMapCenter = (object) => ({
    type: agentsTypes.SET_MAP_CENTER,
    object,
});
const setMapZoom = (number) => ({
    type: agentsTypes.SET_MAP_ZOOM,
    number,
});
const setLoading = (boolean) => ({
    type: agentsTypes.SET_LOADING,
    boolean,
});
const setSearchCount = (number) => ({
    type: agentsTypes.SET_SEARCH_COUNT,
    number,
});

const fetchAgents = (address, name, distance, searchCount, isSearchForm) => async (dispatch) => {
    let distanceFloat = parseFloat(distance);
    dispatch(setLoading(true));
    dispatch(setLastSearchAddress(address));
    dispatch(setLastSearchName(name));
    let response;
    if (address && name) {
        if (/^[0-9]+$/.test(address)) {
            response = await api.get(`/agents?postalCode=${address}&name=${name}&state=TX&page=1&distance=${distanceFloat}&unit=miles`);
        } else {
            response = await api.get(`/agents?city=${address}&name=${name}&state=TX&page=1&distance=${distanceFloat}&unit=miles`);
        }
    } else if (address) {
        if (/^[0-9]+$/.test(address)) {
            response = await api.get(`/agents?postalCode=${address}&state=TX&page=1&distance=${distanceFloat}&unit=miles`);
        } else {
            response = await api.get(`/agents?city=${address}&state=TX&page=1&distance=${distanceFloat}&unit=miles`);
        }
    } else if (name) {
        response = await api.get(`/agents?name=${name}&state=TX&page=1`);
    } else {
        dispatch(setAgentsList([]));
        dispatch(setNoAgents(true));
        dispatch(setLoading(false));
        return false;
    }

    // API Platform returns data in hydra:member format
    const dataArray = response.data?.['hydra:member'] || response.data || [];
    
    if (dataArray && dataArray.length > 0) {
        let agentsList = [];
        let latArr = [];
        let lngArr = [];
        dataArray.forEach((agent, index) => {
            agent.agentKey = index + 1;
            let agentAddressesArr;
            if (agent.addresses) {
                if (Array.isArray(agent.addresses)) {
                    agentAddressesArr = agent.addresses;
                } else {
                    agentAddressesArr = Object.values(agent.addresses)
                }
            }
            if (agentAddressesArr.length > 0) {
                agent.address = [];
                agentAddressesArr.forEach(addressObj => {
                    if (addressObj.type &&
                        addressObj.type === 'Physical' &&
                        addressObj['street'] &&
                        addressObj['street'].length > 0) {
                            agent.latitude = addressObj.latitude;
                            latArr.push(addressObj.latitude);
                            agent.longitude = addressObj.longitude;
                            lngArr.push(addressObj.longitude);
                            let address = addressObj['street'];
                            if (addressObj.city && addressObj.city.length > 0) {
                                address = address + ', ' + addressObj.city
                            }
                            if (addressObj.state && addressObj.state.length > 0) {
                                address = address + ', ' + addressObj.state
                            }
                            if (addressObj.postalCode && addressObj.postalCode.length > 0) {
                                address = address + ', ' + formatPostalCode(addressObj.postalCode)
                            }
                            agent.address.push({id: addressObj.id, address: address})
                    }

                })
            }
            agentsList.push(agent)
        })
        dispatch(setMapCenter({lat: getMapCenter(latArr), lng: getMapCenter(lngArr)}));
        dispatch(setMapZoom(8));
        dispatch(setAgent({}));
        dispatch(setHoveredAgent(0));
        dispatch(setAgentsList(agentsList));
        dispatch(setLoading(false));
        dispatch(setNoAgents(false));
        if (isSearchForm) {
            dispatch(setSearchCount(searchCount + 1));
        }
    } else {
        dispatch(setAgentsList([]));
        dispatch(setAgent({}));
        dispatch(setHoveredAgent(0));
        dispatch(setNoAgents(true));
        dispatch(setLoading(false));
    }

    if (address) {
        dispatch(setSearchByMap(true));
    } else {
        dispatch(setSearchByMap(false));
    }

    return false;
};

const formatPostalCode = (zip) => {
    let value = zip.substring(0, 9);
    if (value.length > 5) {
        value = [value.slice(0, 5), '-', value.slice(5)].join('');
    }
    return value
}

const fetchAgent = (id) => async (dispatch) => {
    dispatch(setLoading(true));
    const response = await api.get(`/agents/${id.id}`);
    dispatch(setAgent(response.data));
    dispatch(setLoading(false));
};

const getMapCenter = (locations) => {
    if (locations && locations.length > 0) {
        let min = Math.min( ...locations );
        let max = Math.max( ...locations );
        return (min + max) / 2;
    } else {
        return false;
    }
}

const fetchAgency = (id) => async (dispatch) => {
    const response = await api.get(`/agencies/${id}`);
    dispatch(setAgency(response.data));
};


export default {
    setAgentsList,
    setNoAgents,
    setSearchByMap,
    setSearchAddress,
    setLastSearchAddress,
    setSearchAddressError,
    setSearchName,
    setLastSearchName,
    setSearchNameError,
    setSearchError,
    fetchAgents,
    fetchAgent,
    setAgent,
    setHoveredAgent,
    fetchAgency,
    setAgency,
    setDetailsOpen,
    setModalOpen,
    setModalSuccessOpen,
    setActiveMarker,
    setMapCenter,
    setSearchCount
};
